import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import { AppAbilityInterface } from 'config/ability';

export const AbilityContext = createContext<AppAbilityInterface>(undefined!);

export default createContextualCan(AbilityContext.Consumer);
